import { CheckOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Popover } from 'antd';
import { ShowContentWrapper } from 'components/rest/Filter/styles';
import { useChangeShowLayout } from 'hooks/useShowLayout';
import { xor } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { IRestColumnProps } from '../Table/TableColumn';
import { useTranslation } from 'react-i18next';

type TFilterButton = {
  content?: React.ReactElement;
  columns?: IRestColumnProps[];
  showColumns?: string[];
};

const ContentShow = ({ content, columns, showColumns }: TFilterButton) => {
  const changeShowLayout = useChangeShowLayout();
  const { t } = useTranslation();
  const [searchKey, setSearchKey] = useState('');

  const onSelect = (e: IRestColumnProps) => {
    changeShowLayout(xor(showColumns, [e.name]));
  };

  const onChangeSearch = useCallback((e) => {
    setSearchKey(e.target.value);
  }, []);
  const shows = useMemo<IRestColumnProps[]>(() => {
    return columns.filter(
      (e: IRestColumnProps) =>
        showColumns.includes(e.name) &&
        (!searchKey ||
          `${e.title}`.toLocaleLowerCase().indexOf(searchKey) > -1),
    );
  }, [showColumns, searchKey, columns]);

  const unShowColumns = useMemo<IRestColumnProps[]>(() => {
    return columns.filter(
      (e: IRestColumnProps) =>
        !showColumns.includes(e.name) &&
        (!searchKey ||
          `${e.title}`.toLocaleLowerCase().indexOf(searchKey) > -1),
    );
  }, [showColumns, searchKey, columns]);
  return (
    content || (
      <ShowContentWrapper>
        <Input
          className="search-input"
          placeholder="Search"
          onChange={onChangeSearch}
          prefix={<SearchOutlined />}
        />
        <div className="v-show-content">
          {!!shows?.length && (
            <div className="text-sm fw-500">{t('common.showFields')}</div>
          )}
          {shows?.map((e) => (
            <div
              key={e.name}
              role="presentation"
              onClick={() => onSelect(e)}
              className="d-flex pointer mt-2.5 space-between"
            >
              <div className="note">{e.title as React.ReactNode}</div>
              <CheckOutlined className="text-highlight" />
            </div>
          ))}
          {!!shows?.length && <Divider />}
          <div className="text-sm fw-500">{t('common.fieldsInTheSpace')}</div>
          {unShowColumns
            .filter((e) => e.name)
            ?.map((e) => (
              <div
                key={e.name}
                role="presentation"
                onClick={() => onSelect(e)}
                className="d-flex pointer mt-2.5 space-between"
              >
                <div className="note">{e.title as React.ReactNode}</div>
              </div>
            ))}
        </div>
      </ShowContentWrapper>
    )
  );
};

export default function ShowButton({
  content,
  columns,
  showColumns,
}: TFilterButton) {
  const [open, setOpen] = useState(false);
  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="bottomRight"
      content={
        <ContentShow
          content={content}
          columns={columns}
          showColumns={showColumns}
        />
      }
      openClassName="popover-inner-0"
      rootClassName="popover-inner-0"
    >
      <Button size="large" className="text-sm" icon={<EyeOutlined />}>
        Show
      </Button>
    </Popover>
  );
}
